module.exports = __webpack_public_path__ + "img/Y7.8ded3872.png";